module.exports = "/legacy/272db8dece74b126562b069619c4173b.svg";